const normalizeText = (value) => (value || '').trim().toLowerCase();

const normalizeControllerName = (value) => (
    (value || '')
        .replace(/\s*\([^)]*\)\s*$/, '')
        .trim()
);

const userMatchesController = (user, controller) => {
    const controllerName = normalizeControllerName(controller?.name || controller?.controller);
    const controllerEmail = normalizeText(controller?.email || controller?.username);

    return (
        (controllerEmail && (
            normalizeText(user?.email) === controllerEmail ||
            normalizeText(user?.username) === controllerEmail
        )) ||
        (controllerName && normalizeText(user?.name) === normalizeText(controllerName))
    );
};

const controllerExistsInUsers = (users = [], controller) => (
    Boolean(controller) && users.some((user) => userMatchesController(user, controller))
);

const getControllerDisplayName = (controller) => (
    normalizeControllerName(controller?.name || controller?.controller) ||
    controller?.email ||
    'Selected user'
);

export {
    controllerExistsInUsers,
    getControllerDisplayName,
};
